var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scratchWroks container" }, [
    _c("div", { staticClass: "worksInfo" }, [
      _c("div", { staticClass: "worksInfo-top" }, [
        _c("img", { attrs: { src: _vm.themeData.logo, alt: "" } }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "works" }, [
      _vm.scratchLoading
        ? _c("div", { staticClass: "worksLoading" }, [
            _c("img", { attrs: { src: _vm.themeData.logo, alt: "" } }),
            _vm._v(" "),
            _c("div", { staticClass: "scratch-loading" }, [
              _c("div", {
                staticClass: "filled",
                style: `width: ${_vm.width}%`,
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "works-play", attrs: { id: "scratch-player" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.keyboard != 1,
              expression: "keyboard != 1",
            },
          ],
          staticClass: "panel-container f-cb",
        },
        [
          _vm.keyboard == 2
            ? _c("div", { staticClass: "keyboardBox" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", {
                  staticClass: "space f-fr",
                  attrs: { id: "mspaceBtn" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "q", attrs: { id: "mqBtn" } }, [
                  _vm._v("Q"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "w", attrs: { id: "mwBtn" } }, [
                  _vm._v("W"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "e", attrs: { id: "meBtn" } }, [
                  _vm._v("E"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.keyboard == 3
            ? _c("div", { staticClass: "keyboardBox" }, [
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.keyboard == 4
            ? _c("div", { staticClass: "keyboardBox" }, [_vm._m(3)])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "playGame", attrs: { id: "playGame" } }, [
            _vm._v("开始"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stopGame", attrs: { id: "stopGame" } }, [
            _vm._v("结束"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "heatWork" }, [
        _c(
          "div",
          [
            _c("svg-icon", { attrs: { "icon-class": "zan" } }),
            _vm._v(_vm._s(_vm.likeNum) + "\n\t\t\t\t\t"),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c("i", { staticClass: "el-icon-view" }),
          _vm._v(_vm._s(_vm.visNum)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "explain" }, [
        _c("h5", [_vm._v("作品简介：")]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.description))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "explain" }, [
        _c("h5", [_vm._v("操作说明：")]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.direction))]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "comment" }, [
      _c("h5", [_vm._v("评论：")]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "commentList" },
        _vm._l(_vm.commentList, function (item, index) {
          return _c("li", { key: index, staticClass: "commentLi" }, [
            _c("img", {
              staticClass: "commentAvatar",
              attrs: { src: item.reviewerAvatar, alt: "" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "commentinfo" }, [
              _c("span", { staticClass: "reviewerName" }, [
                _vm._v(_vm._s(item.reviewerName)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "createDate" }, [
                _vm._v(_vm._s(item.createDate)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "commentContent" }, [
                _vm._v(_vm._s(item.content)),
              ]),
              _vm._v(" "),
              item.discussions
                ? _c(
                    "ul",
                    _vm._l(item.discussions, function (dis, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "commentLi" },
                        [
                          _c("img", {
                            staticClass: "commentAvatar",
                            attrs: { src: dis.replierAvatar, alt: "" },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "commentinfo" }, [
                            _c("span", { staticClass: "reviewerName" }, [
                              _vm._v(_vm._s(dis.replierName)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "createDate" }, [
                              _vm._v(_vm._s(dis.createDate)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "commentContent" }, [
                              _vm._v(_vm._s(dis.content)),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ])
        }),
        0
      ),
      _vm._v(" "),
      !_vm.commentList.length
        ? _c("span", { staticClass: "noComment" }, [_vm._v("暂无评论")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footerJoinBox" }, [
      _c("a", {
        staticClass: "footerJoin",
        attrs: {
          href: `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${_vm.themeData.wxAppId}&redirect_uri=https%3a%2f%2fwww.${_vm.institutionConfig.baseDomainName}%2fjiaxiao%2fjoinStudy%3fitid%3d${_vm.themeData.id}%26atid%3d${_vm.authorId}&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=wx18ec7edf87151a7e#wechat_redirect`,
        },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sxzu-bar-one" }, [
      _c("div", {
        staticClass: "key left arrow-left",
        attrs: { id: "mleftBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key down arrow-down",
        attrs: { id: "mdownBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key right arrow-right",
        attrs: { id: "mrightBtn" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "key up arrow-up", attrs: { id: "mupBtn" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sxzu-bar" }, [
      _c("div", {
        staticClass: "key left arrow-left",
        attrs: { id: "mleftBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key down arrow-down",
        attrs: { id: "mdownBtn" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "key right arrow-right",
        attrs: { id: "mrightBtn" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "key up arrow-up", attrs: { id: "mupBtn" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sxzu-bar-wasd" }, [
      _c("div", { staticClass: "key keyW arrow-w", attrs: { id: "mwBtn" } }, [
        _vm._v("W"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key keyA arrow-a", attrs: { id: "maBtn" } }, [
        _vm._v("A"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key keyS arrow-s", attrs: { id: "msBtn" } }, [
        _vm._v("S"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key keyD arrow-d", attrs: { id: "mdBtn" } }, [
        _vm._v("D"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "num-keypad" }, [
      _c("div", { staticClass: "key number", attrs: { id: "m7Btn" } }, [
        _vm._v("7"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m8Btn" } }, [
        _vm._v("8"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m9Btn" } }, [
        _vm._v("9"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m4Btn" } }, [
        _vm._v("4"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m5Btn" } }, [
        _vm._v("5"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m6Btn" } }, [
        _vm._v("6"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m1Btn" } }, [
        _vm._v("1"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m2Btn" } }, [
        _vm._v("2"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "key number", attrs: { id: "m3Btn" } }, [
        _vm._v("3"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/scratchwork/scratchwork.vue?vue&type=template&id=0e35d546&scoped=true&
// module id = null
// module chunks = 